/**
 * 海报 api
 */
import { API_PREFIX } from '@shared/config';
import { httpClient } from '@shared/utils';
import { type ApiResult } from '../apis';

// 海报类别列表
export const getPosterTypeList = async <U, T>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/poster/list_poster_type`, params);

// 海报列表
export const getPosterList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/poster/list`, params);
